import type { DropdownMenuPlacement } from 'components/Dropdown/types/DropdownMenuPlacement';
import { useSearchRefinementDropdown } from 'modules/search/components/Refinement/Dropdown/useSearchRefinementDropdown';
import type { SearchRefinementType } from 'modules/search/constants/refinements/searchRefinementTypes';
import { useSearchFacetSelectedValues } from 'modules/search/hooks/facets/useSearchFacetSelectedValues';

export function useSearchFacetDropdown(
  facetType: SearchRefinementType,
  initialPlacement?: DropdownMenuPlacement,
) {
  const selectedFacetValues = useSearchFacetSelectedValues(facetType);

  const hasSelectedFacetValues = selectedFacetValues.length > 0;

  const { holderRef, placement, toggleDropdown, dropdownStatus } =
    useSearchRefinementDropdown(
      facetType,
      hasSelectedFacetValues,
      initialPlacement,
    );

  return { holderRef, dropdownStatus, toggleDropdown, placement };
}
